import i18next, { t } from "i18next";
import { useContext, useEffect, useState } from "react";
import { UserContext } from "../../../contexts/user.context";
import NoData from "../../../components/noData/noData.component";
import AddEditVacationRequestTypeModal from "../../../components/modals/AddEditVacationRequestTypeModal/AddEditVacationRequestTypeModal.component";
import { Delete, Get, handleError } from "../../../utils/fetch.util";
import { FiEdit } from "react-icons/fi";
import { RiDeleteBinLine } from "react-icons/ri";
import { toast } from "react-toastify";
import ConfirmationModal from "../../../components/modals/confirmationModal/confirmationModal.component";

interface VacationRequestType {
  id: number;
  name_en: string;
  name_ar: string;
}

const VacationRequestTypes = () => {
  const [vacationRequestsTypes, setVacationRequestsTypes] = useState<any[]>([]);
  const { getValidToken, permissions } = useContext(UserContext);
  const [openAddVacationRequestType, setOpenAddVacationRequestType] =
    useState<boolean>(false);
  const [editVacationRequestType, setEditVacationRequestType] =
    useState<any>(null);
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [vacantionrequestTypeId, setVacantionrequestTypeId] =
    useState<number>(0);
  const [isConfirmationModalOpen, setIsConfirmationModalOpen] =
    useState<boolean>(false);

  const getAllVacationRequestTypes = async () => {
    setIsLoading(true);
    const res = await Get(
      "vacation-request-type/get-all-vacation-request-types",
      getValidToken(),
    );

    if (res.error || !res.data) {
      setIsLoading(false);
      handleError(res);
      return;
    }

    setIsLoading(false);
    setVacationRequestsTypes(res.data);
  };

  const deleteVacationRequestType = async () => {
    setIsLoading(true);
    const res = await Delete(
      `vacation-request-type/delete-vacation-request-type?type_id=${vacantionrequestTypeId}`,
      getValidToken(),
    );

    setIsLoading(false);
    if (res.error || !res.data) {
      handleError(res);
      return;
    }
    toast.success("Successfully Deleted");
    getAllVacationRequestTypes();
  };

  useEffect(() => {
    getAllVacationRequestTypes();
  }, []);

  return (
    <>
      <div className="container bg-white p-6 px-8">
        <div className="flex items-center justify-between my-5">
          <h1 className="text-5xl">
            {t("vacation_types")}
            <span className="text-2xl">({vacationRequestsTypes?.length})</span>
          </h1>

          <button
            className="main_btn"
            onClick={() => setOpenAddVacationRequestType(true)}
          >
            {t("add_vacation_type")}
          </button>
        </div>
        {vacationRequestsTypes?.length === 0 ? (
          <div className="flex justify-center items-center h-[500px]">
            <NoData message={t("no_vacation_types")} />
          </div>
        ) : (
          <div className="overflow-x-auto">
            <table className="w-full mt-5 mb-5">
              <thead className="w-full">
                <tr className="border-collapse border-2 w-full">
                  <th
                    className={`border-collapse border-2 p-3 min-w-[80px] ${
                      i18next.language === "ar" ? "text-right" : "text-left"
                    }`}
                  >
                    {t("id")}
                  </th>
                  <th
                    className={`border-collapse border-2 p-3 min-w-[80px] ${
                      i18next.language === "ar" ? "text-right" : "text-left"
                    }`}
                  >
                    {t("name_en")}
                  </th>
                  <th
                    className={`border-collapse border-2 p-3 min-w-[80px] ${
                      i18next.language === "ar" ? "text-right" : "text-left"
                    }`}
                  >
                    {t("name_ar")}
                  </th>
                  {(permissions?.VacationRequest.update ||
                    permissions?.VacationRequest.delete) && (
                    <th
                      className={`border-collapse border-2 p-3 min-w-[80px] ${
                        i18next.language === "ar" ? "text-right" : "text-left"
                      }`}
                    >
                      {t("actions")}
                    </th>
                  )}
                </tr>
              </thead>
              <tbody>
                <tr className="h-6">
                  <td className=""></td>
                  <td className=""></td>
                  <td className=""></td>
                  <td className=""></td>
                  <td className=""></td>
                  <td className=""></td>
                </tr>
                {vacationRequestsTypes.length > 0 &&
                  vacationRequestsTypes.map((item: VacationRequestType) => {
                    return (
                      <tr key={item.id} className="border-collapse border-2">
                        <td className="p-3 border-collapse border-2 capitalize min-w-[80px]">
                          {item.id}
                        </td>
                        <td className="p-3 border-collapse border-2 capitalize min-w-[80px]">
                          {item.name_en}
                        </td>
                        <td className="p-3 border-collapse border-2 capitalize min-w-[80px]">
                          {item.name_ar}
                        </td>

                        {(permissions?.VacationRequest.update ||
                          permissions?.VacationRequest.delete) && (
                          <td className="p-3 border-collapse border-2 capitalize min-w-[80px]">
                            <div className="flex gap-2">
                              {permissions?.VacationRequest.update && (
                                <button
                                  className=""
                                  onClick={() => {
                                    setEditVacationRequestType(item);
                                    setOpenAddVacationRequestType(true);
                                  }}
                                >
                                  <FiEdit className="text-xl text-text cursor-pointer" />
                                </button>
                              )}

                              {permissions?.VacationRequest.delete && (
                                <button
                                  className="text-red-500 cursor-pointer"
                                  onClick={() => {
                                    setIsConfirmationModalOpen(true);
                                    setVacantionrequestTypeId(item.id);
                                  }}
                                >
                                  <RiDeleteBinLine className="text-[1.40rem] text-red-500 cursor-pointer" />
                                </button>
                              )}
                            </div>
                          </td>
                        )}
                      </tr>
                    );
                  })}
              </tbody>
            </table>
          </div>
        )}
      </div>

      <AddEditVacationRequestTypeModal
        open={openAddVacationRequestType}
        setOpen={setOpenAddVacationRequestType}
        editVacationRequestType={editVacationRequestType}
        setEditVacationRequestType={setEditVacationRequestType}
        getAllItems={getAllVacationRequestTypes}
      />

      <ConfirmationModal
        title={t("delete_vacation_type")}
        message={t("confirm_delete")}
        isLoading={isLoading}
        onConfirm={() => {
          deleteVacationRequestType();
          setIsConfirmationModalOpen(false);
        }}
        closeConfirmationModal={() => setIsConfirmationModalOpen(false)}
        isShown={isConfirmationModalOpen}
        strict={true}
      />
    </>
  );
};

export default VacationRequestTypes;
